import React from 'react';
import { nanoid } from 'nanoid';

import Facebook from 'icons/social/facebook.svg';
import Linkedin from 'icons/social/linkedin.svg';
import Twitter from 'icons/social/twitter.svg';
import { useGetImageFullPath } from 'helpers';
import DepartmentContacts from 'components/Contact-us/components/Offices/DepartmentContacts';
import { companyContacts } from 'components/Contact-us/constants/company-contacts';

import { MenuLinks } from './components';

type attachmentItem = {
  title: string;
  link: string;
};

interface Props {
  attachments: attachmentItem[];
  socialMediaUrls: string[];
}

const getSocialNetworkNameByIndex = (index: number) => {
  switch (index) {
    case 0:
      return 'Facebook';
    case 1:
      return 'Linkedin';
    case 2:
      return 'Twitter';
    default:
      return '';
  }
};

export const Footer = ({ attachments, socialMediaUrls }: Props) => {
  const awardImage = useGetImageFullPath('BrandonHallGroup_Award_Gold2023.webp');

  return (
    <footer className="footer">
      <div className="darken-background" />
      <div className="container award-container footer-inner footer-first">
        <div className="award-icon footer-item-first">
          <img width="254" height="180" loading="lazy" src={awardImage} alt="Brandon Hall Group Award Gold 2023" />
        </div>
        <MenuLinks />

        {companyContacts.footerContacts.map((contact) => (
          <div key={contact.country} className="footer-item-first">
            <DepartmentContacts key={contact.country} title={contact.country} contacts={[contact]} />
          </div>
        ))}
      </div>
      <div className="separator" />
      <div className="container footer-inner">
        <div className="footer-item terms navigation">
          <p>&copy; {new Date().getFullYear()} Itransition</p>
          <ul className="footer-navigation">
            {attachments.map(({ title, link }) => (
              <li className="footer-navigation-item" key={nanoid()}>
                <a className="footer-navigation-link" href={link} aria-label="Additional info:">
                  {title}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-item social">
          <ul className="footer-navigation">
            {socialMediaUrls.map((url, index) => (
              <li className="footer-social-item" key={nanoid()}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={url}
                  aria-label={`Join us on ${getSocialNetworkNameByIndex(index)}`}
                >
                  {index === 0 && <Facebook />}
                  {index === 1 && <Linkedin />}
                  {index === 2 && <Twitter />}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};
